<template>
  <Tooltip>
    <template #title>
      <slot name="title"></slot>
    </template>
    <img style="width: 16px" class="icon" src="@/assets/icon/hint.svg" alt="">
  </Tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Tooltip } from 'ant-design-vue'
const _Tooltip = defineComponent({
  components: { 
    Tooltip
  },
  props: ['content'],
  emits: ['update:value', 'change'],
  setup () {
    return {
    }
  }
})

export default _Tooltip
</script>

<style lang="less">

// .ant-select-selector {
//   border-color: #D7150E!important;
// }
// .ant-select-selector:hover {
//   border-color: #333!important;
// }

</style>
